import { useSelector } from 'react-redux';
import { actions as offerReduxActionTypes } from '@makemydeal/dr-offer-redux';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import * as manualFieldOverridesSelectors from '@makemydeal/dr-dash-store/selectors/manualFieldOverridesSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as programsSelectors from '@makemydeal/dr-dash-store/selectors/programsSelectors';

export const SELECTED_TERM_ACTION = offerReduxActionTypes.SELECTED_TERM;

/**
 * Term, Payment Frequency, and Offer Type changes all reconfirm eligibility for the term that ends up
 * current after the action: neither Payment Frequency nor Offer Type changes termMonths itself, so a
 * no-program outcome either one triggers is still about that term. Annual Miles is deliberately left out -
 * mileage is its own program-matching dimension, so a no-program outcome it triggers may be about the
 * mileage tier rather than the term, and the term-specific message would misattribute the cause.
 */
const TERM_MESSAGE_TRIGGERS: ReadonlySet<string> = new Set([
    SELECTED_TERM_ACTION,
    offerReduxActionTypes.UPDATED_PAYMENT_FREQUENCY,
    offerReduxActionTypes.UPDATED_OFFER_TYPE
]);

export const useTermNotSupported = (): boolean => {
    const isImprovedAutoSelectEnabled = useSelector(featureToggleSelectors.isImprovedAutoSelectEnabled);
    const isPaymentFrequencyTermMessageEnabled = useSelector(featureToggleSelectors.isPaymentFrequencyTermMessageEnabled);
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const isAutoSelectOn = useSelector((state: StateTree) =>
        manualFieldOverridesSelectors.getResolvedAutoSelectChecked(state, offerType)
    );
    const noProgramTrigger = useSelector((state: StateTree) => programsSelectors.getNoProgramLookupTrigger(state, offerType));

    if (!isImprovedAutoSelectEnabled || !isAutoSelectOn) {
        return false;
    }

    if (!isPaymentFrequencyTermMessageEnabled) {
        return noProgramTrigger === SELECTED_TERM_ACTION;
    }

    return !!noProgramTrigger && TERM_MESSAGE_TRIGGERS.has(noProgramTrigger);
};
